export const MAX_QUICK_REPLY_BUTTONS = 7;
export const QUICK_REPLY_VARIANT = {
  DEFAULT: 'default',
  SPOTLIGHT: 'spotlight'
};